import Swiper from "swiper";
import { Navigation, Pagination, Keyboard, A11y } from "swiper/modules";

const swiper = new Swiper('.carouselBlock', {
    modules: [Navigation, Pagination, Keyboard, A11y],
    preloadImages: false,
    autoHeight: true,
    loop: true,

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: false,
    },
    a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
    },
});



const sliderBlocks = document.querySelectorAll('.sliderBlock');

sliderBlocks.forEach((slider) => {
    const uniqueSliderGuid = slider.dataset.number;
    new Swiper(".sliderBlock" + uniqueSliderGuid, {
        modules: [Navigation, Pagination, Keyboard, A11y],
        preloadImages: false,
        spaceBetween: 30,
        slidesPerView: 2,
        scrollbar: {
            draggable: true,
        },

        breakpoints: {
            991: {
                slidesPerView: 3,
            }
        },

        pagination: {
            el: '.swiper-slider-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-slider-button-next' + uniqueSliderGuid,
            prevEl: '.swiper-slider-button-prev' + uniqueSliderGuid,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: false,
        },
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
    });
})

